import React from "react";
import Header from "../Header";
import Banner from "../Banner";
import Video from "../Video";
import CardTexto from "../CardTexto";
import Cartas from "../Cartas";
import Kawaii from "../Kawaii";
import CardGps from "../CardGps";
import Galeria from "../Galeria";
import Join from "../Join";
import Footer from "../Footer";
export default function Home() {
  return (
    <div>
      <Header />
      <Banner />
      <Video />
      <CardTexto />
      <Cartas />
      <Kawaii />
      <CardGps />
      <Galeria />
      <Join />
      <Footer />
    </div>
  );
}
